import toast from '@/components/Toast';

const messages = {
  remove: {
    id: 'documents.bulkActions.remove',
    defaultMessage: '{success} out of {total} documents were removed',
  },
  removePermanently: {
    id: 'documents.bulkActions.removePermanently',
    defaultMessage: '{success} out of {total} documents were permanently deleted',
  },
  signSuccess: {
    id: 'documents.bulkActions.addSignatures',
    defaultMessage: '{success} out of {total} documents were submitted for signing',
  },
  changeTypeSuccess: {
    id: 'documents.bulkActions.addTags',
    defaultMessage: '{success} out of {total} documents were modified',
  },
  bulkAcceptSuccess: {
    id: 'documents.bulkActions.published',
    defaultMessage: '{success} of {total} documents were scheduled for Publishing',
  },
  printFetchError: {
    id: 'selectedPanel.toast.print.fetch.error',
    defaultMessage: 'We encountered a printing issue, please try again',
  },
  sendToPaySuccess: {
    id: 'documents.bulkActions.sendToPay',
    defaultMessage: '{success} out of {total} documents were sent to Pay',
  },
};

export default messages;

export function makeTost(translate) {
  return (action, args = {}, type = 'info') => {
    toast[type](translate(messages[action], args));
  };
}
